import React, { useContext, useState, useRef } from 'react';
import { Button, makeStyles } from '@material-ui/core';
import AssessmentsList from '../Assessments/List/AssessmentsList';
import ContentWrapper from '../Wrappers/ContentWrapper';
import { FAKE_TITLE_DATA } from '../Shared/FakeDataGenerator';
import { ActivePatientContext } from '../../contexts/ActivePatientProvider';
import { useParams } from 'react-router-dom';
import { PATIENT_TABLE_NAMES } from '../../config/routes';
import OrdersList from '../Orders/List/OrdersList';
import { checkPermission } from '../../helpers/checkPermissions';
import permissions from '../../config/permissions';
import { useSelector } from 'react-redux';
import ClaimsReportingList from '../Claims/List/ClaimsReportingList';
import ClaimReportList from '../ClaimReport/List/СlaimReportList';
import PatientInfoBlock from './widgets/PatientInfoBlock';
import PatientAdditionalNode from './widgets/PatientAdditionalNode';
import ReportablesList from '../Reportable/List/ReportablesList';
import PatientActions from '../Patients/PatientActions';
import { useLocation } from 'react-router';
import EditIcon from '@material-ui/icons/Edit';
import ResourcesList from '../Resources/List/ResourcesList';
import TableTitle from '../Shared/Table/widgets/TableTitle';
import ProgramList from '../Programs/List/ProgramList';
import { GET_ASSESSMENTS_COLUMNS } from '../Assessments/constants';
import { GET_RESOURCES_COLUMNS } from '../Resources/constants';
import { GET_ORDER_COLUMNS } from '../Orders/constants';
import { GET_CLAIMS_COLUMNS } from '../Claims/constants';
import { GET_REPORTABLES_COLUMNS } from '../Reportable/constants';
import { GET_PROGRAMS_COLUMNS } from '../Programs/constants';

const useStyles = makeStyles((theme) => ({
  paper: {
    overflow: 'hidden',
  },
  actions: {
    overflow: 'hidden',
    minWidth: 220,
    flex: '1 100 auto',
    height: 60,
  },
  addNewButton: {
    height: '100%',
    marginRight: theme.spacing(2),
    padding: 20,
  },
  editButton: {
    border: 'none !important',
    width: 34,
    maxWidth: 34,
    minWidth: 34,
    height: 34,
    borderRadius: '50%',
    transition: '300ms',
  },
  editButtonIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 32,
    height: 32,
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    flex: '100 1 auto',
    maxWidth: '100%',
  },
}));

const PatientDashboard = ({}) => {
  const classes = useStyles();
  const { en: { titles } } = useSelector((state) => state.i18n);
  const [filterStyle, setFilterStyle] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const { patientUuid, patientInfo } = useContext(ActivePatientContext);
  const { search } = useLocation();
  const [orderPatientUuid, setOrderPatientUuid] = useState(null); // trigger useOrderMetadata
  const [openResourceModal, toggleResourceModal] = useState(false);
  const [openPatientEditModal, togglePatientEditModal] = useState(false);
  const [openAssessmentModal, toggleAssessmentModal] = useState(search.includes('create'));
  const [openProgramModal, toggleProgramModal] = useState(false);
  const tableRef = useRef();
  const {
    patientUuid: paramsPatientUuid,
    tableName,
  } = useParams();

  const {
    metadata: { currentAccountPermissions, childAccountPermissions },
    isDistributionSponsor,
  } = useSelector((state) => state.user);

  const isClaimsAvailable = checkPermission(
    isDistributionSponsor ? childAccountPermissions : currentAccountPermissions,
    permissions.CLAIMS_GET,
  );

  const isClaimReportAvailable = checkPermission(
    currentAccountPermissions,
    permissions.CLAIM_REPORTS_GET,
  ) && false; // remove if claim Report List enabled to patient page;

  const isResourcesAvailable = checkPermission(
    currentAccountPermissions,
    permissions.GET_RESOURCES,
  );

  const handleEditPatient = () => {
    togglePatientEditModal(true);
  };

  const titleText = patientInfo ? `${patientInfo.lastName}, ${patientInfo.firstName}` : FAKE_TITLE_DATA;

  return <>
    <PatientActions
      orderPatientUuid={orderPatientUuid}
      setOrderPatientUuid={setOrderPatientUuid}
      openAssessmentModal={openAssessmentModal}
      toggleAssessmentModal={toggleAssessmentModal}
      openResourceModal={openResourceModal}
      toggleResourceModal={toggleResourceModal}
      openPatientEditModal={openPatientEditModal}
      togglePatientEditModal={togglePatientEditModal}
      openProgramModal={openProgramModal}
      toggleProgramModal={toggleProgramModal}
      reloadList={(v) => {
        tableRef.current?.reloadList(v);
      }}
    />
    <ContentWrapper
      titleText={<div className={classes.titleContainer}>
        <div style={{
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
        }}>
          {titleText}
        </div>
        <Button
          variant={'outlined'}
          color={'primary'}
          onClick={handleEditPatient}
          className={classes.editButton}
        >
          <div className={classes.editButtonIcon}>
            <EditIcon style={{ width: 20, height: 20 }} />
          </div>
        </Button>
      </div>}
      className={classes.paper}
      titleContainerStyle={{
        flexWrap: 'nowrap',
      }}
      titleStyle={{
        flex: '100 1 auto',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
      }}
      hasTopPaddingForSmallScreen={true}
      underTitleText={
        <PatientInfoBlock
          isForInitLoading={
            (patientUuid !== paramsPatientUuid) || !patientInfo
          }
        />
      }
      countFiltered={filterStyle}
      actionsStyle={classes.actions}
      actions={<PatientAdditionalNode
        toggleAssessmentModal={toggleAssessmentModal}
        toggleResourceModal={toggleResourceModal}
        setOrderPatientUuid={setOrderPatientUuid}
        toggleProgramModal={toggleProgramModal}
        activeTableName={tableName}
        tabs={Object.values(PATIENT_TABLE_NAMES)}
        tableKey={'patientDashboard'}
      />}
    >
      <div style={{ position: 'relative', height: '100%', width: '100%' }}>
        {
          tableName === PATIENT_TABLE_NAMES.assessments && <AssessmentsList
            setFilterStyle={setFilterStyle}
            setTotalCount={setTotalCount}
            tableTitle={<TableTitle
              titleText={titles.assessments}
              count={totalCount}
              countFiltered={filterStyle}
              smallStyle
            />}
            ref={tableRef}
            q={`patientUUID:${paramsPatientUuid}`}
            hideMenuActions={true}
            columnList={GET_ASSESSMENTS_COLUMNS(true)}
          />
        }
        {
          tableName === PATIENT_TABLE_NAMES.resources && <ResourcesList
            setFilterStyle={setFilterStyle}
            setTotalCount={setTotalCount}
            tableTitle={<TableTitle
              titleText={titles.resources}
              count={totalCount}
              countFiltered={filterStyle}
              smallStyle
            />}
            ref={tableRef}
            q={`patientUUID:${paramsPatientUuid}`}
            hideMenuActions={true}
            columnList={GET_RESOURCES_COLUMNS(true)}
          />
        }
        {
          tableName === PATIENT_TABLE_NAMES.orders && <OrdersList
            setFilterStyle={setFilterStyle}
            setTotalCount={setTotalCount}
            tableTitle={<TableTitle
              titleText={titles.orders}
              count={totalCount}
              countFiltered={filterStyle}
              smallStyle
            />}
            ref={tableRef}
            q={`patientUUID:${paramsPatientUuid}`}
            hideMenuActions={true}
            columnList={GET_ORDER_COLUMNS(true)}
          />
        }
        {
          tableName === PATIENT_TABLE_NAMES.claimsReporting && <ClaimsReportingList
            setFilterStyle={setFilterStyle}
            setTotalCount={setTotalCount}
            tableTitle={<TableTitle
              titleText={titles.claimsReporting}
              count={totalCount}
              countFiltered={filterStyle}
              smallStyle
            />}
            ref={tableRef}
            q={`patientUUID:${paramsPatientUuid}`}
            hideMenuActions={true}
            columnList={GET_CLAIMS_COLUMNS(true)}
          />
        }
        {
          tableName === PATIENT_TABLE_NAMES.claimReport && <ClaimReportList
            setFilterStyle={setFilterStyle}
            setTotalCount={setTotalCount}
            tableTitle={<TableTitle
              titleText={titles.claimReport}
              count={totalCount}
              countFiltered={filterStyle}
              smallStyle
            />}
            ref={tableRef}
            q={`patientUUID:${paramsPatientUuid}`}
          />
        }
        {
          tableName === PATIENT_TABLE_NAMES.reportables && <ReportablesList
            setFilterStyle={setFilterStyle}
            setTotalCount={setTotalCount}
            tableTitle={<TableTitle
              titleText={titles.reportables}
              count={totalCount}
              countFiltered={filterStyle}
              smallStyle
            />}
            ref={tableRef}
            q={`patientUUID:${paramsPatientUuid}`}
            columnList={GET_REPORTABLES_COLUMNS(true)}
          />
        }
        {
          tableName === PATIENT_TABLE_NAMES.programs && <ProgramList
            setFilterStyle={setFilterStyle}
            setTotalCount={setTotalCount}
            tableTitle={<TableTitle
              titleText={titles.programs}
              count={totalCount}
              countFiltered={filterStyle}
              smallStyle
            />}
            ref={tableRef}
            q={`patientUUID:${paramsPatientUuid}`}
            hideMenuActions={true}
            columnList={GET_PROGRAMS_COLUMNS(true)}
          />
        }
      </div>
    </ContentWrapper>
  </>;
};

export default PatientDashboard;
